var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMetricalLogoWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 479.967,
    height: 87.474,
    viewBox: "0 0 479.967 87.474",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 65.606h359.975V0H0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 87.474)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v21.142c0 4.181-.789 8.126-5.128 8.126-4.418 0-6.311-3.945-6.311-9.309V0h-12.623v21.142c0 4.812-1.103 8.126-5.205 8.126-4.418 0-6.312-3.945-6.312-9.309V0h-12.622v38.892h12.622l-.078-5.601.157.078c1.973 3.235 5.759 6.233 10.729 6.233 5.365 0 9.625-1.815 11.596-7.1 2.762 4.733 6.627 7.1 12.386 7.1 9.939 0 13.49-6.785 13.49-16.172V0Z",
    fill: "#fff",
    transform: "translate(118.525 5.543)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-5.206 0-7.889-4.103-8.046-7.81H7.968C7.889-4.26 5.286 0 0 0m19.564-14.989H-8.125c.552-5.601 4.812-8.125 9.939-8.125 5.049 0 9.467 2.209 11.676 3.708l4.97-6.548C17.198-26.9 12.07-32.266 0-32.266c-11.991 0-20.747 7.416-20.747 20.275C-20.747.868-11.28 8.204.237 8.204c11.518 0 19.486-7.652 19.486-19.012 0-1.893-.159-4.181-.159-4.181",
    fill: "#fff",
    transform: "translate(156.543 36.94)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-13.963c0-3.392.236-5.759 4.103-5.759 1.971 0 3.786.71 3.786.71l.631-9.861c-.947-.236-4.417-1.263-8.994-1.263-10.097 0-12.227 6.154-12.227 15.069V0h-5.523v9.545h5.523v10.571H0V9.545h8.599V0Z",
    fill: "#fff",
    transform: "translate(197.089 34.811)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-.553c-.71.395-2.366.947-4.575.947-6.232 0-7.81-5.838-7.81-10.966v-17.276h-12.623v38.892h12.623l-.079-5.523h.158c2.209 4.261 5.443 6.233 9.625 6.233 2.602 0 3.944-.71 3.944-.71z",
    fill: "#fff",
    transform: "translate(236.689 32.838)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.208 44.435h12.622V5.543h-12.622z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-10.65 0-20.511 7.258-20.511 20.195 0 13.017 10.019 20.275 20.668 20.275 9.941 0 14.437-4.102 14.437-4.102l-2.761-9.546a15.99 15.99 0 0 1-10.019 3.471c-5.364 0-9.624-3.707-9.624-9.86 0-6.154 3.866-10.019 9.782-10.019 5.917 0 9.861 3.786 9.861 3.786l2.998-9.545C14.437 4.339 10.334 0 0 0",
    fill: "#fff",
    transform: "translate(280.388 4.675)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-3.866-.158-6.153-1.814-6.153-4.733 0-2.998 2.445-4.813 5.916-4.813 3.392 0 5.68 2.209 6.468 3.55V.395zm6.705-16.725-.236 4.103c-1.657-1.657-4.813-4.971-11.123-4.971-6.864 0-14.121 3.708-14.121 12.386 0 8.678 7.967 11.597 15.146 11.912l9.782.395v.868c0 4.101-2.919 6.231-7.967 6.231-4.97 0-9.941-2.209-11.913-3.47l-3.313 8.204c3.313 1.657 9.388 3.944 16.645 3.944 12.149 0 19.17-5.049 19.17-17.671v-21.931z",
    fill: "#fff",
    transform: "translate(316.895 22.268)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.031 62.027h12.622V5.736h-12.622z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-33.358h13.473V6.173Z",
    fill: "#fff",
    transform: "translate(5.98 38.902)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-42.176h13.932V6.173Z",
    fill: "#fff",
    transform: "translate(24.677 47.72)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0v-49.273h13.932V7.21Z",
    fill: "#fff",
    transform: "translate(43.834 54.817)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0a7.153 7.153 0 0 0-7.154-7.153A7.154 7.154 0 1 0 0 0",
    fill: "#fff",
    transform: "translate(255.674 55.145)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricalLogoWhite);
export default __webpack_public_path__ + "static/media/metrical-logo-white.6813d80d767b178d78c3f7c8e0820f87.svg";
export { ForwardRef as ReactComponent };